import { render, staticRenderFns } from "./CreateGoalModal.vue?vue&type=template&id=6b132c40&scoped=true&"
import script from "./CreateGoalModal.vue?vue&type=script&lang=ts&"
export * from "./CreateGoalModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGoalModal.vue?vue&type=style&index=0&id=6b132c40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b132c40",
  null
  
)

export default component.exports